import { render, staticRenderFns } from "./fieldsSort.vue?vue&type=template&id=40646e3a&scoped=true&"
import script from "./fieldsSort.vue?vue&type=script&lang=js&"
export * from "./fieldsSort.vue?vue&type=script&lang=js&"
import style0 from "./fieldsSort.vue?vue&type=style&index=0&id=40646e3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40646e3a",
  null
  
)

export default component.exports